export const DOWNLOAD_LOADING_TEXT =
  'Preparing your report (This could take a minute)'
export const DOWNLOAD_DATA_TEST_ID = 'download-report-link'
export const ERROR_MESSAGE =
  'There was a problem preparing the report. Try again.'
